import React, { useContext as useContextCore } from 'react'
import type { UseErrorResult } from '@ztechapps/common.hook'
import { useError } from '@ztechapps/common.hook'
import type { BomSummary } from '@ztechapps/product.common'

export type AdjustmentProviderProps = {
  children: React.ReactNode
  onAfterAction?: () => void
} & BomSummary
export type AdjustButtonContext = {
  useErrorResult: UseErrorResult
} & Omit<AdjustmentProviderProps, 'children'>

const context = React.createContext<AdjustButtonContext>({} as AdjustButtonContext)
const CoreProvider = context.Provider

export const AdjustButtonProvider = ({ children, product, onAfterAction, ...props }: AdjustmentProviderProps) => {
  const useErrorResult = useError()
  return (
    <CoreProvider
      value={{
        ...props,
        product,
        onAfterAction,
        useErrorResult,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useAdjustButtonContext = () => useContextCore(context)
